import React, { useEffect, useRef, useState } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  List,
  ListItem,
  Paper,
} from "@mui/material";
import RoomIcon from "@mui/icons-material/Room";

export default function LocationField({
  street,
  setStreet,
  setCoordinates,
  handlePinLocation,
  isPinning,
}) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);

  const searchLocation = (value) => {
    setQuery(value);
    if (value.length < 3) {
      setResults([]);
      return;
    }

    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${value}&countrycodes=ke&limit=5`
        );
        const data = await res.json();
        setResults(data);
      } catch (error) {
        console.error("Search error:", error);
      }
      setLoading(false);
    }, 600); // ✅ wait 400ms after last keystroke
  };
  useEffect(() => {
    if (street) {
      setQuery(street); // ✅ show saved location in the input
    }
  }, [street]);

  const handleSelect = (place) => {
    setStreet(place.display_name); // confirmed
    setCoordinates({ lat: parseFloat(place.lat), lng: parseFloat(place.lon) });
    setResults([]);
    setQuery(place.display_name); // show in input too
  };

  return (
    <div style={{ position: "relative" }}>
      <TextField
        fullWidth
        variant="outlined"
        label="Search or Pin Location 👉"
        placeholder="Type a place..."
        value={query} // ✅ only query
        onChange={(e) => searchLocation(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {loading || isPinning ? (
                <CircularProgress size={20} color="error" />
              ) : (
                <IconButton edge="end" onClick={handlePinLocation}>
                  <RoomIcon style={{ color: "#ff4d4f" }} />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
      />

      {results.length > 0 && (
        <Paper
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 10,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          <List>
            {results.map((place, i) => (
              <ListItem
                key={i}
                button
                onClick={() => handleSelect(place)}
                style={{ fontSize: "0.9rem" }}
              >
                {place.display_name}
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </div>
  );
}
